export const SET_MATCHES_BY_TOURNAMENTS = 'SET_MATCHES_BY_TOURNAMENTS';
export const SELECT_JOURNAL_BY_MATCH = 'SELECT_JOURNAL_BY_MATCH';
export const RESET_SELECT_JOURNAL = 'RESET_SELECT_JOURNAL';